import { useLanguage } from "@/contexts/LanguageContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Shield, Mail, MapPin } from "lucide-react";
import { legalTranslations } from "@/i18n/legalTranslations";

export default function PrivacyPolicyPage({ user, onLogout, refreshUserData }) {
  const { language } = useLanguage();
  const t = legalTranslations[language]?.privacy || legalTranslations.fr.privacy;

  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar user={user} onLogout={onLogout} refreshUserData={refreshUserData} />

      <div className="h-20"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center p-3 bg-brand-100 rounded-full mb-4">
            <Shield className="h-8 w-8 text-brand-600" />
          </div>
          <h1 className="text-3xl font-bold text-slate-800">{t.pageTitle}</h1>
          <p className="text-slate-600 mt-2">{t.lastUpdated}</p>
        </div>

        {/* Content */}
        <div className="prose prose-slate max-w-none bg-white rounded-xl shadow-sm p-8">
          
          {/* Introduction */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-slate-800 mb-4">{t.intro.title}</h2>
            <p>{t.intro.p1}</p>
            <p className="mt-4">{t.intro.p2}</p>
          </section>

          {/* Collection */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-slate-800 mb-4">{t.collection.title}</h2>
            <p>{t.collection.p1}</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              {t.collection.items.map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>
          </section>

          {/* Use */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-slate-800 mb-4">{t.use.title}</h2>
            <p>{t.use.p1}</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              {t.use.items.map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>
          </section>

          {/* Sharing */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-slate-800 mb-4">{t.sharing.title}</h2>
            <p>{t.sharing.p1}</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              {t.sharing.items.map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>
          </section>

          {/* Security */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-slate-800 mb-4">{t.security.title}</h2>
            <p>{t.security.p1}</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              {t.security.items.map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>
          </section>

          {/* Rights */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-slate-800 mb-4">{t.rights.title}</h2>
            <p>{t.rights.p1}</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              {t.rights.items.map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>
            <p className="mt-4">{t.rights.p2}</p>
          </section>

          {/* Retention */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-slate-800 mb-4">{t.retention.title}</h2>
            <p>{t.retention.p1}</p>
          </section>

          {/* Cookies */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-slate-800 mb-4">{t.cookies.title}</h2>
            <p>{t.cookies.p1}</p>
          </section>

          {/* Contact */}
          <section className="mb-4">
            <h2 className="text-xl font-bold text-slate-800 mb-4">{t.contact.title}</h2>
            <p>{t.contact.p1}</p>
            <div className="bg-slate-50 p-4 rounded-lg mt-4 space-y-2">
              <div className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-slate-500" />
                <a href="mailto:privacy@middleman.ca" className="text-brand-600 hover:underline">privacy@middleman.ca</a>
              </div>
              <div className="flex items-center gap-2">
                <MapPin className="h-4 w-4 text-slate-500" />
                <span>Montréal, Québec, Canada</span>
              </div>
            </div>
          </section>

        </div>
      </div>

      <Footer />
    </div>
  );
}
